'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _countryData = require('country-data');

var _formatting = require('../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCountry = function getCountry(code) {
  return _lodash2.default.find(_countryData.countries.all, ['alpha2', _lodash2.default.upperCase(code)]);
};

var COUNTRIES_TO_DISPLAY = 20;

var DemographicsYoutubeDataTable = function DemographicsYoutubeDataTable(_ref) {
  var data = _ref.audienceLocations.data;

  var displayed = _lodash2.default.take(data, COUNTRIES_TO_DISPLAY);
  var restOfWorld = _lodash2.default.filter(data, function (item) {
    return !_lodash2.default.find(displayed, ['countryCode', item.countryCode]);
  });
  return _react2.default.createElement(
    _semanticUiReact.Table,
    { singleLine: true, textAlign: 'center' },
    _react2.default.createElement(
      _semanticUiReact.Table.Header,
      null,
      _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        { textAlign: 'left' },
        'country'
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        null,
        'views'
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        null,
        'mins watched'
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        null,
        'likes'
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        null,
        'comments'
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        null,
        'dislikes'
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        null,
        'shares'
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        null,
        _react2.default.createElement(_semanticUiReact.Popup, {
          trigger: _react2.default.createElement(
            'span',
            null,
            'subs ',
            _react2.default.createElement(_semanticUiReact.Icon, { circular: true, name: 'plus', color: 'green' })
          ),
          content: _react2.default.createElement(
            'span',
            null,
            'subscribers gained'
          )
        })
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        null,
        _react2.default.createElement(_semanticUiReact.Popup, {
          trigger: _react2.default.createElement(
            'span',
            null,
            'subs ',
            _react2.default.createElement(_semanticUiReact.Icon, { circular: true, name: 'minus', color: 'red' })
          ),
          content: _react2.default.createElement(
            'span',
            null,
            'subscribers lost'
          )
        })
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        null,
        _react2.default.createElement(_semanticUiReact.Popup, {
          trigger: _react2.default.createElement(
            'span',
            null,
            'videos ',
            _react2.default.createElement(_semanticUiReact.Icon, { circular: true, name: 'plus', color: 'green' })
          ),
          content: _react2.default.createElement(
            'span',
            null,
            'videos added to playlists'
          )
        })
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        null,
        _react2.default.createElement(_semanticUiReact.Popup, {
          trigger: _react2.default.createElement(
            'span',
            null,
            'videos ',
            _react2.default.createElement(_semanticUiReact.Icon, { circular: true, name: 'minus', color: 'red' })
          ),
          content: _react2.default.createElement(
            'span',
            null,
            'videos removed from playlists'
          )
        })
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Body,
      null,
      _lodash2.default.map(displayed, function (row) {
        var country = getCountry(row.countryCode);
        return _react2.default.createElement(
          _semanticUiReact.Table.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { textAlign: 'left' },
            country.emoji,
            ' ',
            country.name
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            (0, _formatting.commaFormatted)(row.views)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            (0, _formatting.commaFormatted)(row.estimatedMinutesWatched)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            (0, _formatting.commaFormatted)(row.likes)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            (0, _formatting.commaFormatted)(row.comments)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            (0, _formatting.commaFormatted)(row.dislikes)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            (0, _formatting.commaFormatted)(row.shares)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            (0, _formatting.commaFormatted)(row.subscribersGained)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            (0, _formatting.commaFormatted)(row.subscribersLost)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            (0, _formatting.commaFormatted)(row.videosAddedToPlaylists)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            (0, _formatting.commaFormatted)(row.videosRemovedFromPlaylists)
          )
        );
      }),
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { textAlign: 'left' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'globe', color: 'pink' }),
          ' Rest of World'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'views'))
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'estimatedMinutesWatched'))
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'likes'))
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'comments'))
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'dislikes'))
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'shares'))
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'subscribersGained'))
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'subscribersLost'))
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'videosAddedToPlaylists'))
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfWorld, 'videosRemovedFromPlaylists'))
        )
      )
    )
  );
};

DemographicsYoutubeDataTable.propTypes = {
  audienceLocations: _propTypes2.default.object.isRequired
};

exports.default = DemographicsYoutubeDataTable;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/demographics-youtube-data-table/index.js
 ** module id = 969
 ** module chunks = 0
 **/